import { render, staticRenderFns } from "./AvatarsGroup.vue?vue&type=template&id=f76dbf10&scoped=true&"
import script from "./AvatarsGroup.vue?vue&type=script&lang=ts&"
export * from "./AvatarsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarsGroup.vue?vue&type=style&index=0&id=f76dbf10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76dbf10",
  null
  
)

export default component.exports